/**
 * Amizek Minimal Menu Handler
 * Minimal approach that won't conflict with Liquid
 */

(function() {
  'use strict';
  
  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }
  
  // Minimal menu enhancement
  function enhanceMenu() {
    // Only enhance on desktop
    if (window.innerWidth <= 768) {
      return;
    }
    
    // Find the main menu
    const menu = document.querySelector('.header__inline-menu');
    if (!menu) {
      return;
    }
    
    // Ensure menu is centered
    menu.style.display = 'flex';
    menu.style.justifyContent = 'center';
    menu.style.alignItems = 'center';
    menu.style.width = '100%';
    
    // Style menu items
    const menuItems = menu.querySelectorAll('.header__menu-item');
    menuItems.forEach(item => {
      item.style.margin = '0 20px';
      
      // Style links
      const link = item.querySelector('a');
      if (link) {
        link.style.color = '#000';
        link.style.textDecoration = 'none';
        link.style.fontWeight = '500';
        link.style.fontSize = '16px';
        link.style.padding = '10px 0';
        link.style.transition = 'color 0.2s ease';
        
        // Add hover effect
        link.addEventListener('mouseenter', function() {
          this.style.color = '#dc3545';
        });
        
        link.addEventListener('mouseleave', function() {
          this.style.color = '#000';
        });
      }
      
      // Handle dropdowns
      const dropdown = item.querySelector('.header__menu-dropdown');
      if (dropdown) {
        dropdown.style.position = 'absolute';
        dropdown.style.top = '100%';
        dropdown.style.left = '50%';
        dropdown.style.transform = 'translateX(-50%)';
        dropdown.style.background = 'white';
        dropdown.style.border = '1px solid #ddd';
        dropdown.style.borderRadius = '4px';
        dropdown.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
        dropdown.style.zIndex = '1000';
        dropdown.style.minWidth = '200px';
        dropdown.style.padding = '10px 0';
        dropdown.style.display = 'none';
        dropdown.style.marginTop = '5px';
        
        // Show dropdown on hover
        item.addEventListener('mouseenter', function() {
          dropdown.style.display = 'block';
        });
        
        item.addEventListener('mouseleave', function() {
          dropdown.style.display = 'none';
        });
        
        // Style dropdown items
        const dropdownItems = dropdown.querySelectorAll('a');
        dropdownItems.forEach(dropdownItem => {
          dropdownItem.style.display = 'block';
          dropdownItem.style.padding = '10px 20px';
          dropdownItem.style.color = '#333';
          dropdownItem.style.textDecoration = 'none';
          dropdownItem.style.background = 'white';
          dropdownItem.style.fontSize = '14px';
          dropdownItem.style.transition = 'background-color 0.2s ease';
          
          dropdownItem.addEventListener('mouseenter', function() {
            this.style.backgroundColor = '#f8f9fa';
            this.style.color = '#dc3545';
          });
          
          dropdownItem.addEventListener('mouseleave', function() {
            this.style.backgroundColor = 'white';
            this.style.color = '#333';
          });
        });
      }
    });
  }
  
  // Initialize
  ready(enhanceMenu);
  
  // Re-run on resize
  window.addEventListener('resize', function() {
    setTimeout(enhanceMenu, 100);
  });
  
})();
